/**
 * ISS-18 — should the per-minute `calendarTick` interval keep running?
 *
 * The interval exists solely to force `computed` consumers that depend on
 * `Date.now()` (e.g. live raid status chips in the calendar) to re-evaluate.
 * With no guild selected there are no raids to time-stamp and the calendar
 * is closed, so the callback would be a no-op. The `'0'` sentinel is the
 * canonical "no guild chosen yet" value — see `isValidGuildSnowflake` in
 * `../stores/gvgPlannerStore.ts`.
 *
 * Lives in `lib/` (not the store file) so a `node --test` regression test
 * can import the predicate without dragging in Pinia / Apollo / Vue — the
 * store itself is too heavy to load in a plain Node test runner.
 */
export function isCalendarTickActive(activeDiscordGuildId: string): boolean {
  return activeDiscordGuildId !== '0'
}
